import { removeCSS, updateCSS } from "@rc-component/util/es/Dom/dynamicCSS";
import { useContext } from 'react';
import StyleContext, { ATTR_MARK, ATTR_TOKEN, CSS_IN_JS_INSTANCE } from "../StyleContext";
import { injectCSPNonce, isClientSide, toStyleStr } from "../util";
import { transformToken } from "../util/css-variables";
import useGlobalCache from "./useGlobalCache";
import { uniqueHash } from "./useStyleRegister";
export const CSS_VAR_PREFIX = 'cssVar';
const useCSSVarRegister = (config, fn) => {
  const {
    key,
    prefix,
    unitless,
    ignore,
    token,
    hashId,
    scope,
    nonce
  } = config;
  const {
    cache: {
      instanceId
    },
    container,
    hashPriority
  } = useContext(StyleContext);
  const {
    _tokenKey: tokenKey
  } = token;
  const scopeKey = Array.isArray(scope) ? scope.join('@@') : scope;
  const stylePath = [...config.path, key, scopeKey, tokenKey];
  const cache = useGlobalCache(CSS_VAR_PREFIX, stylePath, () => {
    const originToken = fn();
    const [mergedToken, cssVarsStr] = transformToken(originToken, key, {
      prefix,
      unitless,
      ignore,
      scope,
      hashPriority,
      hashCls: hashId
    });
    const styleId = uniqueHash(stylePath, cssVarsStr);
    return [mergedToken, cssVarsStr, styleId, key];
  }, ([,, styleId]) => {
    if (isClientSide) {
      removeCSS(styleId, {
        mark: ATTR_MARK,
        attachTo: container
      });
    }
  }, ([, cssVarsStr, styleId]) => {
    if (!cssVarsStr) {
      return;
    }
    let mergedCSSConfig = {
      mark: ATTR_MARK,
      prepend: 'queue',
      attachTo: container,
      priority: -999
    };
    mergedCSSConfig = injectCSPNonce(mergedCSSConfig, nonce);
    const style = updateCSS(cssVarsStr, styleId, mergedCSSConfig);
    style[CSS_IN_JS_INSTANCE] = instanceId;

    // Used for `useCacheToken` to remove on batch when token removed
    style.setAttribute(ATTR_TOKEN, key);
  });
  return cache;
};
export const extract = (cache, effectStyles, options) => {
  const [, styleStr, styleId, cssVarKey] = cache;
  const {
    plain
  } = options || {};
  if (!styleStr) {
    return null;
  }
  const order = -999;

  // ====================== Style ======================
  // Used for @rc-component/util
  const sharedAttrs = {
    'data-rc-order': 'prependQueue',
    'data-rc-priority': `${order}`
  };
  const styleText = toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};
export default useCSSVarRegister;